// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2019-01-25T10:26:47Z                      #

// ##############################################################

import ErrorApi from "./../../../utils/ErrorApi";
import Fetch from "./../../../utils/Fetch";
import ParamsFetch from "./../../../utils/ParamsFetch";
import JsonFetch from "./../../../utils/JsonFetch";
import generateUrl from './../../../utils/generateUrl';

import * as UpdateMethods from "./UpdateMethods";

/**
 * Rychle prihlaseni v Marbesu pomoci univerzalniho hesla Generated from cz.marbes.react.MarbesAuthController.
 */
export default class MarbesAuthApi {
    /**
     * Přihlášení pomocí OpenId. Po tomto volání je nutné na klientovy udělat refresh stránky!
     *
     * @return 
     */
    static loginByOpenId() : Promise<boolean> {
        const uri = serverContextPath + `/api/auth/loginbyopenid`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     */
    static logout() {
        const uri = serverContextPath + `/api/auth/logout`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param redir 
     */
    static ntlm(redir : string) {
        const uri = serverContextPath + `/api/auth/ntlm`;
        const headers = undefined;
        const params = { redir };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @return 
     */
    static check() : Promise<AuthStatus> {
        const uri = serverContextPath + `/api/auth/check`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param credentials 
     * @return 
     */
    static login(credentials : AuthCredentials) : Promise<AuthStatus> {
        const uri = serverContextPath + `/api/auth/login`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, credentials, headers));
    }

    /**
     * Zjištění zda je Openid nakonfigurované.
     *
     * @return TRUE - je nokonfigurovaní openId
     */
    static isOpenIdConfigured() : Promise<boolean> {
        const uri = serverContextPath + `/api/auth/isopenidconfigured`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

}